import script from "./OrderDetailsEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDetailsEntry.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDetailsEntry.vue?vue&type=style&index=0&id=1c7f9947&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7f9947"]])

export default __exports__